import { AccessPermissions } from '../../core/types.js';

/**
 * We will use this permission to hide certain parts of the app that are not ready for the public.
 */ const RESTRICTED = {
    access: AccessPermissions.restricted
};

export { RESTRICTED };
//# sourceMappingURL=restricted.js.map
